import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';

const SuiteFeatureTableBadge = ({
  use = 'new',
  translationKey = 'recommended',
  badgeStyle
}) => {
  return /*#__PURE__*/_jsx(UIBadge, {
    use: use,
    style: Object.assign({
      position: 'absolute'
    }, badgeStyle),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `badges.${translationKey}`
    })
  });
};

export default SuiteFeatureTableBadge;